export default {
    map: {},
    units: [],
    models: [],
    objects: [],
    activePath: [],
    sessionId: null,
    landscape: false,
    activeStep: null,
    activeStepIndex: null,
    appLoaded: false,
    mapLoading: true,
    terminalId: null,
    terminalCode: null,
    listsAndItems: [],
    activeLocale: 'en',
    defaultLocale: 'en',
    integrationId: null,
    dataSourceType: null,
    mapLoadingProgress: 0,
    activeMapTheme: 'default',
    lastModified: null,
    canUpdateMapData: false,
    unfilteredMapObjects: null,
    isMapDataUpdateNeeded: false,
    lastModifiedCheckedAt: null,
    isMobileGuideStartActivate: false
}
